import React from "react";
import { animated as a, useTrail } from "@react-spring/native";

export const TrailAnimation = ({ children }) => {
  const components = React.Children.toArray(children);
  const springs = useTrail(components.length, {
    to: [
      {
        marginTop: 0,
        opacity: 1,
      },
    ],
    from: {
      opacity: 0,
      marginTop: 30,
    },
  });

  return springs.map(({ ...style }, index) => {
    return (
      <a.View
        key={index}
        style={[
          style,
          {
            width: "100%",
          },
        ]}
      >
        {components[index]}
      </a.View>
    );
  });
};
